// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/app/components/ConnectionIssuesLinks.module.css';
import type {StatusPageIncident} from '@app/features/user/state/StatusPage';
import {ExternalUrls} from '@app/vendor/constants/ExternalUrls';
import {Trans} from '@lingui/react/macro';

interface ConnectionIssuesLinksProps {
	incident: StatusPageIncident | null;
	className?: string;
}

const STATUS_HISTORY_URL = `${ExternalUrls.SERVICE_STATUS}/history`;
export function ConnectionIssuesLinks({incident, className}: ConnectionIssuesLinksProps) {
	const containerClassName = className != null ? `${styles.container} ${className}` : styles.container;
	const incidentUrl = incident?.url ?? STATUS_HISTORY_URL;
	return (
		<div className={containerClassName}>
			<p className={styles.prompt}>
				<Trans>Connection issues?</Trans>
			</p>
			<p className={styles.links}>
				<a href={ExternalUrls.SERVICE_STATUS} target="_blank" rel="noopener noreferrer" className={styles.link}>
					<Trans>Status Page</Trans>
				</a>
				<span aria-hidden="true" className={styles.separator}>
					·
				</span>
				<a href={incidentUrl} target="_blank" rel="noopener noreferrer" className={styles.link}>
					{incident ? <Trans>Read Incident</Trans> : <Trans>Incident History</Trans>}
				</a>
			</p>
		</div>
	);
}
